module.exports = __webpack_public_path__ + "static/media/Chuvoso.73db3d3e.svg";